export const getSeasonName = (alias, season) => {
  let seasonName = "";
  switch (season) {
    case "OPTIMAL":
      seasonName = alias.bfcSummer;
      break;
    case "ISOLENT":
      seasonName = alias.bfcSpringFall;
      break;
    case "ISOMAX":
      seasonName = alias.bfcWinter;
      break;

    default:
      break;
  }
  return seasonName;
};
